// /** @module maps/google */
import {BaseMap} from "./map_base";
import "./gmap_clusterer";
import {OSMOverlay} from "./gmap_osm_overlay";
import {getUrl} from "../main_ptx";

/**
 * @alias Ptx.maps.Google
 */
export const GoogleMap = BaseMap.extend({
    /** @lends module:maps/google */
    /**
     * Common clusterOpts for TYPE_TRACE and TYPE_TRACE_ANALYZE map type.
     */
    traceClusterOpts: function () {
        return {
            'general': {gridSize: 50, maxZoom: 15},
            'vehicle': {gridSize: 50, maxZoom: 12},
            'tp': {
                gridSize: 8, maxZoom: 14, clusterClass: 'tp-cluster'
                , styles: [{
                    url: getUrl('/img/tp-cluster-black-min.png'),
                    width: 1,
                    height: 1,
                    textColor: '#ff00ff',
                    textSize: 0.1
                }, {
                    url: getUrl('/img/tp-cluster-black-min.png'),
                    width: 1,
                    height: 1,
                    textColor: '#ff0000',
                    textSize: 0.1
                }, {
                    url: getUrl('/img/tp-cluster-black-min.png'),
                    width: 1,
                    height: 1,
                    textColor: '#0000ff',
                    textSize: 0.1
                }]
            }
        }
    },
    clusterOpts: {
        //KEYs for this clusterOpts are the same as Ptx.maps.TYPE_ constants, as defined in maps_base
        //this is used to define different cluster options for different map types
        'TYPE_MAIN': {
            'general': {gridSize: 50, maxZoom: 15},
            'vehicle': {
                gridSize: 50, maxZoom: 12, clusterClass: 'vehicle-cluster'
                , styles: [{
                    url: getUrl('/img/vehicle-cluster-min.png'),
                    width: 30,
                    height: 30,
                    textColor: '#FFF'
                }, {
                    url: getUrl('/img/vehicle-cluster-mid.png'),
                    width: 37,
                    height: 37,
                    textColor: '#FFF'
                }, {
                    url: getUrl('/img/vehicle-cluster-max.png'),
                    width: 44,
                    height: 44,
                    textColor: '#FFF'
                }]
            },
            'tp': {
                gridSize: 8, maxZoom: 12, clusterClass: 'tp-cluster'
                , styles: [{
                    url: getUrl('/img/tp-cluster-black-min.png'),
                    width: 1,
                    height: 1,
                    textColor: '#ff00ff',
                    textSize: 0.1
                }, {
                    url: getUrl('/img/tp-cluster-black-min.png'),
                    width: 1,
                    height: 1,
                    textColor: '#ff0000',
                    textSize: 0.1
                }, {
                    url: getUrl('/img/tp-cluster-black-min.png'),
                    width: 1,
                    height: 1,
                    textColor: '#0000ff',
                    textSize: 0.1
                }]
            },
            'poi-marker': {
                gridSize: 70, maxZoom: 18, ignoreHidden: true, clusterClass: 'poi-cluster'
                , styles: [{
                    url: getUrl('/img/poi-cluster.png'),
                    width: 30,
                    height: 30,
                    textColor: '#FFF'
                }, {
                    url: getUrl('/img/poi-cluster.png'),
                    width: 30,
                    height: 30,
                    textColor: '#FFF'
                }, {
                    url: getUrl('/img/poi-cluster.png'),
                    width: 35,
                    height: 35,
                    textColor: '#FFF'
                }]
            },
            'poi-circle': {
                gridSize: 70, maxZoom: 18, ignoreHidden: true, clusterClass: 'tp-cluster'
                , styles: [{
                    url: getUrl('/img/tp-cluster-black-min.png'),
                    width: 1,
                    height: 1,
                    textColor: '#ff00ff',
                    textSize: 0.1
                }]
            },
            'geozone-circle': {
                gridSize: 70, maxZoom: 18, ignoreHidden: true, clusterClass: 'tp-cluster'
                , styles: [{
                    url: getUrl('/img/tp-cluster-black-min.png'),
                    width: 1,
                    height: 1,
                    textColor: '#ff00ff',
                    textSize: 0.1
                }]
            },
            'geozone-marker': {
                gridSize: 70, maxZoom: 18, ignoreHidden: true, clusterClass: 'poi-cluster'
                , styles: [{
                    url: getUrl('/img/poi-cluster.png'),
                    width: 30,
                    height: 30,
                    textColor: '#FFF'
                }, {
                    url: getUrl('/img/poi-cluster.png'),
                    width: 30,
                    height: 30,
                    textColor: '#FFF'
                }, {
                    url: getUrl('/img/poi-cluster.png'),
                    width: 35,
                    height: 35,
                    textColor: '#FFF'
                }]
            }
        },
        'TYPE_LOGBOOK': {
            'general': {gridSize: 50, maxZoom: 15},
            'vehicle': {gridSize: 50, maxZoom: 12},
            'tp': {
                gridSize: 16, maxZoom: 18, clusterClass: 'tp-cluster'
                , styles: [{
                    url: getUrl('/img/tp-cluster-black-min.png'),
                    width: 1,
                    height: 1,
                    textColor: '#ff00ff',
                    textSize: 0.1
                }, {
                    url: getUrl('/img/tp-cluster-black-min.png'),
                    width: 1,
                    height: 1,
                    textColor: '#ff0000',
                    textSize: 0.1
                }, {
                    url: getUrl('/img/tp-cluster-black-min.png'),
                    width: 1,
                    height: 1,
                    textColor: '#0000ff',
                    textSize: 0.1
                }]
            }
        },
        'TYPE_SIMPLE': {
            'general': {gridSize: 50, maxZoom: 15},
            'vehicle': {gridSize: 50, maxZoom: 12},
            'tp': {
                gridSize: 8, maxZoom: 14, clusterClass: 'tp-cluster'
                , styles: [{
                    url: getUrl('/img/tp-cluster-black-min.png'),
                    width: 1,
                    height: 1,
                    textColor: '#ff00ff',
                    textSize: 0.1
                }, {
                    url: getUrl('/img/tp-cluster-black-min.png'),
                    width: 1,
                    height: 1,
                    textColor: '#ff0000',
                    textSize: 0.1
                }, {
                    url: getUrl('/img/tp-cluster-black-min.png'),
                    width: 1,
                    height: 1,
                    textColor: '#0000ff',
                    textSize: 0.1
                }]
            }
        },
        /** Defined by {@link traceClusterOpts()} method in {@link constructor()} */
        'TYPE_TRACE': undefined,
        /** @see {@link TYPE_TRACE} */
        'TYPE_TRACE_ANALYZE': undefined,
        'TYPE_EOD': {
            'general': {gridSize: 50, maxZoom: 15},
            'tp': {
                gridSize: 50, maxZoom: 12, clusterClass: 'vehicle-cluster'
                , styles: [{
                    url: getUrl('/img/vehicle-cluster-min.png'),
                    width: 30,
                    height: 30,
                    textColor: '#FFF'
                }, {
                    url: getUrl('/img/vehicle-cluster-mid.png'),
                    width: 37,
                    height: 37,
                    textColor: '#FFF'
                }, {
                    url: getUrl('/img/vehicle-cluster-max.png'),
                    width: 44,
                    height: 44,
                    textColor: '#FFF'
                }]
            }
        }
    },

    /**
     GeoJSON geometries style
     */
    geoJsonStyleOpts: {
        'trip': {
            strokeColor: '#00AAFF',
            strokeWeight: 5,
            fillColor: '#00AAFF',
            fillOpacity: 0.25,
            clickable: false
        },
        'trip-fake': {
            strokeColor: '#00AAFF',
            strokeWeight: 5,
            path: 'M 0,-1 0,1',
            strokeOpacity: 1,
            scale: 2,
            dashSpacing: '15px',
            clickable: false
        },
        'DEFAULT': {
            fillColor: '#9B53C3',
            strokeWeight: 0,
            fillOpacity: 0.25,
            clickable: false
        }
    },

    traceIconType: {
        'red': getUrl('/img/redmarker.png'),
        'blue': getUrl('/img/bluemarker.png'),
        'green': getUrl('/img/greenmarker.png'),
        'purple': getUrl('/img/purplemarker.png'),
    },

    //redefined constants
    currentPoint: null,
    logbookMapDefaultZoom: 17,
    showTpDefaultZoom: 9,
    maxDefaultZoom: 15,
    currentInfoBox: null, //currently opened infobox for window
    fakeTrip: [], //object for fake-trips - for deleting old fakeTrips

    constructor: function (mapContainer, opts, mapSettings) {
        this.name = "GM";
        this.base(mapContainer, opts, mapSettings);
        this.clusterOpts['TYPE_TRACE'] = this.traceClusterOpts();
        this.clusterOpts['TYPE_TRACE_ANALYZE'] = this.traceClusterOpts();

        this.onMapTypeChange = this.onMapTypeChange.bind(this);
    },

    /** @see maps/base#loadMap */
    create: function (mapContainer, opts, mapSettings) {
        this.base(mapContainer, opts, mapSettings);
        this.createByStdWay(mapContainer, opts);
    },

	createByStdWay: function (mapContainer, opts) {
		var self = this;

		// PX-2395: Protection against re-including of "Google Maps JavaScript API".
		if (typeof google === 'object' && typeof google.maps === 'object') {
			this.log("API is already included");
			googleMapLibs();
		} else {
			loadScript(createGoogleMapsURL(), googleMapLibs);
		}

		function loadScript(url, callback) {
			var script = document.createElement('script');
			script.src = url;

			script.onload = function () {
				callback(null, script);
			};
			script.onerror = function () {
				callback(new Error("Failed to load: " + url));
			};

			document.head.appendChild(script);
		}

		function createGoogleMapsURL() {
			var params = '?v=' + Ptx.maps.googleMapsVersion;
			if (Ptx.maps.googleKey) params += "&key=" + Ptx.maps.googleKey;
			opts['libraries'] = 'drawing,geometry';
			if (opts.libraries) params += '&libraries=' + opts.libraries;
			return "https://maps.googleapis.com/maps/api/js" + params;
		}

		function googleMapLibs(err, script) {
			if (!err) loadScript(getUrl("/res/dist/js/gmap_bundle.js?_ts=" + Ptx.buildInfoHash), googleMapInit);
		}

		function googleMapInit() {
			var mapOptions = {
				zoom: 8,
				center: new google.maps.LatLng(50.08804, 14.42076), // default Prague pos
				controlSize: 28,
				scaleControl: true,
				gestureHandling: Ptx.fn.isDesktop() ? 'greedy' : 'cooperative',
				fullscreenControl: true,
				fullscreenControlOptions: {
					position: google.maps.ControlPosition.LEFT_TOP
				},
				mapTypeControlOptions: {
					mapTypeIds: ['roadmap', 'terrain', 'hybrid', 'satellite', 'grayscale'],
				},
			};

			self.map = new google.maps.Map(document.getElementById(mapContainer), mapOptions);
			self.ready = true;
			self.clusters = {};
			self.clearClusters(true);
			self.geoBounds = new google.maps.LatLngBounds(); // map bounds
			self.trafficLayer = new google.maps.TrafficLayer();

			self.createGrayscaleFilter();

			// Define what type of map should be prepared
			self.findMapCreatorFunction_();

			// For inherited classes to init some map settings by themselves
			if (typeof self.internalMapInit === 'function') {
				self.internalMapInit(self);
			}

			if (opts.initCallback) {
				opts.initCallback(self);
			}

			self.createLayerControl();
		}
	},

    /**
     * Enables polygon drawing on a Google Map instance and handles the drawn polygons.
     */
    enablePolygonDrawing: function (sendPolygonData) {
        var isDrawingEnabled = false;
        var self = this;
        if (!self.drawnItems) {
            self.drawnItems = new google.maps.MVCArray();
            self.editToolList = {};
        }

        // Remove existing polygons
        self.drawnItems.forEach(function (polygon) {
            polygon.setMap(null);
        });

        if (!self.editToolList.polygon) {
            self.editToolList.polygon = new google.maps.drawing.DrawingManager({
                drawingMode: null, // Set the initial drawing mode to null
                drawingControl: false,
                polygonOptions: {
                    fillColor: '#3388ff',
                    fillOpacity: 0.5,
                    strokeColor: '#3388ff',
                    strokeWeight: 4,
                    editable: true,
                    draggable: true,
                    geodesic: true,
                    zIndex: 1
                },
            });
        }

        self.editTool = self.editToolList.polygon;

        // Remove the previous event listener (if it exists)
        if (self.polygonListener) {
            google.maps.event.removeListener(self.polygonListener);
        }

        // Add the new event listener when drawing is finished
        self.polygonListener = google.maps.event.addListener(self.editTool, 'overlaycomplete', function (e) {
            var polygon = e.overlay;

            self.drawnItems.forEach(function (p) {
                if (p !== polygon) {
                    p.setMap(null);
                }
            });

            self.drawnItems.clear();
            self.drawnItems.push(polygon);

            // Get the polygon coordinates
            var polygonCoordinates = polygon.getPath().getArray().map(function (latLng) {
                return [latLng.lng(), latLng.lat()]; // Note: Longitudes come before latitudes in GeoJSON
            });

            // Duplicate the first point and add it at the end to form a closed ring and send the full polygon to the server
            polygonCoordinates.push(polygonCoordinates[0]);
            sendPolygonData(polygonCoordinates);
            self.editTool.setDrawingMode(null);

            // Disable editing for the drawn polygon
            polygon.setEditable(false);
        });

        if (!isDrawingEnabled) {
            // Enable drawing mode if it's not already enabled
            self.editTool.setDrawingMode(google.maps.drawing.OverlayType.POLYGON);
            isDrawingEnabled = true;
        }

        self.editTool.setMap(self.map);
    },


    /**
     * Create a switch for map layers
     */
	createLayerControl: function () {
		var self = this;

		if (self.mapSettings &&
				self.mapSettings.hasOwnProperty("overlays") &&
				self.mapSettings.overlays.includes("RAILWAY")) {

			function createOptionStructure(text, value, checked) {
				var e_label = document.createElement('label'),
						e_span = document.createElement('span'),
						e_div = document.createElement('div'),
						e_radio = document.createElement('input');
				e_radio.type = "radio";
				e_radio.value = value;
				if (checked) e_radio.setAttribute("checked", "");
				e_radio.name = "google-map-layer-option";
				e_radio.classList.add("google-map-layer-choise");
				e_span.innerText = text;
				e_div.appendChild(e_radio);
				e_div.appendChild(e_span);
				e_label.appendChild(e_div);
				return e_label;
			}

			// Check storage for saved layer selection
			var savedLayer = Ptx.fn.getSession('selectedGoogleMapLayer') || 'basic';

			var basic = createOptionStructure(Ptx.getMsg('map.layer.basic'), "basic", savedLayer === 'basic');
			var rail = createOptionStructure(Ptx.getMsg('map.layer.rail'), "rail", savedLayer === 'rail');
			var railspeed = createOptionStructure(Ptx.getMsg('map.layer.railspeed'), "railspeed", savedLayer === 'railspeed');

			var elem = document.createElement('div'),
					parent = document.createElement('div'),
					container = document.createElement('div'),
					icon = document.createElement('i'),
					map_settings = document.querySelector(".map-settings");

			elem.classList.add('google-map-layer-box');
			container.classList.add("google-map-layer-container");
			parent.classList.add("google-map-layer");
			icon.classList.add("fas"); // IE
			icon.classList.add("fa-layer-group"); // IE
			icon.classList.add("google-map-layer-icon"); // IE

			elem.appendChild(basic);
			elem.appendChild(rail);
			elem.appendChild(railspeed);

			container.appendChild(elem);
			parent.appendChild(icon);
			parent.appendChild(container);
			parent.index = -1; // negative for custom insert in DOM
			if (map_settings) map_settings.insertBefore(parent, map_settings.firstChild);

			// Apply the saved layer initially
			self.toggleLayer({ target: { value: savedLayer } });

			// Save the selected layer to storage and apply it
			$(document).on('click', '.google-map-layer-choise', function (e) {
				var selectedLayer = e.target.value;
				Ptx.fn.setSession('selectedGoogleMapLayer', selectedLayer);
				self.toggleLayer(e);
			});
		}
	},

    createGrayscaleFilter: function () {
        var map = this.map;

        map.mapTypes.set('grayscale', new google.maps.StyledMapType(GRAYSCALE_MAP_TYPE, {name: Ptx.getMsg('map.grayscale')}));

        google.maps.event.addListener(map, "maptypeid_changed", this.onMapTypeChange);
    },

    /**
     * Handle map type change
     * @desc When user change map type from default to grayscale (or inverse), map layer choice DOM needs to be "restarted"
     */
    onMapTypeChange: function () {
        var map = this.map;

        map.overlayMapTypes.removeAt(0);
        var elements = document.querySelectorAll(".google-map-layer-choise");
        if (elements.length > 0) {
            for (var i = 0; i < elements.length; i++) {
                elements[i].checked = false;
            }
            elements[0].checked = true;
        }
    },

    /** @see maps/base#showTpAfterZoom_ */
    showTpAfterZoom: function () {
        var self = this;
        var zoomLevel = self.map.getZoom();
        var clusters = self.clusters['tp'].clusters_;

        for (var i = 0; i < clusters.length; i++) {
            if (zoomLevel < self.showTpDefaultZoom) {
                clusters[i].clusterIcon_.className_ += " hidden";
            }
        }
    },


    /** @see maps/base#unloadMap */
    destroy: function () {
        if (window.google !== undefined && google.maps !== undefined) {
            if (Ptx.page.ctx.destroyGoogleMapCallback) {
                Ptx.page.ctx.destroyGoogleMapCallback();
                return;
            }
            this.log('Destroy map');
            delete google.maps;
            this.ready = false;
            this.base();
            $('script').each(function () {
                //remove google apis
                if (this.src.indexOf('googleapis.com/maps') >= 0
                    || this.src.indexOf('maps.google.com') >= 0
                    || this.src.indexOf('maps.gstatic.com') >= 0
                    || this.src.indexOf('earthbuilder.googleapis.com') >= 0) {
                    $(this).remove();
                }
            });

        }
    },

    resize: function () {
        google.maps.event.trigger(this.map, 'resize');
        this.gjDataShowBounds();
    },

    /** @see maps/base#centerAndZoom */
    centerAndZoom: function (lat, lon, zoom) {
        var m = this.map;
        m.setCenter({lat: lat, lng: lon});
        m.setZoom(zoom);
    },


    /** @see maps/base#zoom */
    zoom: function (zoom) {
        this.map.setZoom(zoom);
    },

    /** @see maps/base#setZoom */
    setZoom: function (zoom) {
        this.zoom(zoom);
    },

    /** @see maps/base#getZoom */
    getZoom: function () {
        return this.map.getZoom();
    },

    /** @see maps/base#setLatLon */
    setLatLng: function (center) {
        this.map.setCenter(center);
    },

    /** @see maps/base#getLatLon */
    getLatLng: function () {
        const center = this.map.getCenter();
        return {
            lat: center.lat(),
            lng: center.lng()
        };
    },

    /** @see maps/base#positionChanged */
    positionChanged: function (callback) {
        this.map.addListener('bounds_changed', callback);
    },

    /** @see maps/base#fitStrBounds */
    fitStrBounds: function (bounds) {
        var points = this.parsePoints(bounds);
        var bounds = new google.maps.LatLngBounds();

        for (var i = 0; i < points.length; i++) {
            bounds.extend(new google.maps.LatLng(points[i].lat, points[i].lon));
        }

        this.map.fitBounds(bounds);
    },

    /**
     * Show drawing data on map
     * @param geoJsonData
     * @param afterLoadCallback
     * @see maps/base#gjDataShow
     */
    gjDataShow: function (geoJsonData, afterLoadCallback) {
        this.base(geoJsonData, afterLoadCallback);
        var self = this;
        var map = self.map;

        self.geoFeatures = map.data.addGeoJson(geoJsonData);
        map.data.setStyle(function (feature) {
            var type = feature.getProperty('type');
            var style = self.getStyleForFeature(type);

			const color = feature.getProperty('color');
			style.strokeColor = color;
			style.fillColor = color;
			style.strokeOpacity = 1;

			if (type === "trip" && feature.getProperty('resolved')) {
				style.strokeOpacity = 0.5;
			}
            return style;
        });

        //remove features that should be removed, as are replaced by markers for example
        map.data.forEach(function (feat) {
            if (feat.removeFromLayer) {
                map.data.remove(feat);
            }
        });

        google.maps.event.addListenerOnce(map, 'idle', function () {
            if (typeof afterLoadCallback === 'function') {
                afterLoadCallback();
            } else {
                self.gjDataShowBounds();
            }
        });

        Ptx.fn.delay(1000, function () {
            google.maps.event.trigger(self.map, 'idle')
        })

        //toggleClusters for all clusters - no @param = use saved value
        this.markerToggleClusters();
        this.markerShowLabels('ALL');
        this.toogleTraffic();
    },

    /** @see maps/base#gjDataShowBounds */
    gjDataShowBounds: function (zoom, autofocus, autozoom) {
        var self = this;
        var map = this.map;
        var isAutofocus = self.autofocus || autofocus;
        var isAutozoom = self.autozoom || autozoom;
        var isZoom = typeof zoom != 'undefined' && zoom != null;
        var mapPosition = Ptx.fn.getSession("mapPosition");

        if (isAutofocus) {
            if (self.geoBounds) {
                var isGeoBoundsInstOfLatLngBounds = self.geoBounds instanceof google.maps.LatLngBounds;
                // are self.geoBounds same as new instance
                var isGeoBoundsSameAsNewInstance = _.isEqual(self.geoBounds, new google.maps.LatLngBounds());
                if (isGeoBoundsInstOfLatLngBounds && isGeoBoundsSameAsNewInstance) {
                    if (mapPosition) map.setCenter(mapPosition.latlng);
                } else {
                    if (isAutozoom) {
                        map.fitBounds(self.geoBounds);
                    } else {
                        map.setCenter(self.geoBounds.getCenter());
                    }
                }
            }
            if (isZoom) {
                map.setZoom(zoom);
            } else {
                if (!isAutozoom) {
                    if (mapPosition) map.setZoom(mapPosition.zoom);
                } else {
                    google.maps.event.addListenerOnce(map, 'bounds_changed', function (event) {
                        if (self.maxDefaultZoom < map.getZoom()) {
                            map.setZoom(self.maxDefaultZoom);
                        }
                    });
                }
            }
        }
    },

    /**
     * Hide drawing on map
     * @see maps/base#gjDataHide
     */
    gjDataHide: function (clearPOI) {
        //uncache pois and geozones
        this.base(clearPOI);
        //remove pure geojson object
        this.removeGeoFeatures();

        //remove markers for clusters (remove markers that are clustered)
        this.clearClusters(clearPOI);
        this.geoBounds = new google.maps.LatLngBounds();

        // destory geozones
        this.geos = [];
        this.clusters['geozone-marker'].clearMarkers();
        this.clusters['geozone-circle'].clearMarkers()
    },

    /**
     * Toggle clustering from settings
     * @param {Boolean} showClusters
     * @see maps/base#markerToggleClusters
     */
    markerToggleClusters: function (showClusters) {
        this.base(showClusters);
        var self = this;

        //"hack" for toggling clusters
        function toggleCluster(clusterName) {
            var clusterOpts = self.clusterOpts[self.opts.mapType][clusterName];

            if (clusterOpts != undefined) {
                if (self.showClusters == true) {
                    self.clusters[clusterName].setMaxZoom(clusterOpts.maxZoom);
                } else {
                    self.clusters[clusterName].setMaxZoom(0);
                }
                self.clusters[clusterName].repaint();
            }
        }

        toggleCluster('vehicle');
        toggleCluster('poi-marker');
        toggleCluster('poi-circle');
        toggleCluster('geozone-marker');
        toggleCluster('geozone-circle');
        toggleCluster('tp');
    },

    /**
     * Toggle POI from settings
     * @param {Boolean} showPoi
     * @see maps/base#togglePoi
     */
    togglePoi: function (showPoi) {
        var self = this
        //part of parent method save showPoi in attribute
        this.base(showPoi)

        function editPoiVisibility(poiArray) {
            poiArray.forEach(function (item) {
                item.setVisible(self.showPoi)
            })
        }

        editPoiVisibility(this.poi);
        //for repainting clusters
        this.markerToggleClusters();
    },


    toggleGeozone: function (showGeozone) {
        this.base(showGeozone)

        this.geos.forEach((it) => {
            it.setVisible(showGeozone)
        });

        this.markerToggleClusters();
    },

    /**
     * Toggle traffic from settings
     * @param traffic
     * @see maps/base#toogleTraffic
     */
    toogleTraffic: function (traffic) {
        this.base(traffic);
        if (this.showTraffic == true) {
            this.trafficLayer.setMap(this.map);
        } else {
            this.trafficLayer.setMap(null);
        }
    },

    /**
     * Toggle between layers
     * @param event
     */
    toggleLayer: function (event) {
        var self = this,
            layer = event.target.value,
            type = true;

        self.map.overlayMapTypes.removeAt(0);
        if (self.map.mapTypeId == "grayscale") type = false;
        switch (layer) {
            case "rail":
                self.map.overlayMapTypes.insertAt(0, new OSMOverlay("rail", type));
                break;
            case "railspeed":
                self.map.overlayMapTypes.insertAt(0, new OSMOverlay("railspeed", type));
                break;
            default:
                self.map.overlayMapTypes.removeAt(0);
        }
    },

    /**
     * Clear all clusters and remove all markers
     * @param {Boolean} clearPOIsAndGeozones
     */
    clearClusters: function (clearPOIsAndGeozones) {
        var self = this;

        //delete all markers from cluster - then create new MarkerClusterer
        function clear(name) {
            if (self.clusters[name]) self.clusters[name].clearMarkers();
            self.clusters[name] = new MarkerClusterer(self.map, [], self.clusterOpts[self.opts.mapType][name]);
        }

        if (typeof self.clusters === 'undefined') {
            self.clusters = {};
        }
        clear('vehicle');
        clear('general');
        clear('tp');
        //when i dont want to remove POIs from map
        if (clearPOIsAndGeozones) {
            clear('poi-marker');
            clear('poi-circle');
            clear('geozone-marker');
            clear('geozone-circle');
        }

        for (var btsIndex = 0, btsSize = self.bts.length; btsIndex < btsSize; btsIndex++) {
            self.bts[btsIndex].setMap(null);
        }
        self.bts = [];

        google.maps.event.addListener(self.clusters['tp'], 'clusteringend', function () {
            self.showTpAfterZoom();
        });
    },

    /**
     * Play animated marker on map
     * @param vehicle
     */
    playAnimatedMarker: function (vehicle) {
        var self = this;
        if (self.AM) {
            self.AM.start();
        } else {
            self.AM = new AnimatedMarker.google;
            self.createAnimatedMarker(vehicle);

            self.forceRefreshMap();
            self.AM.start();
        }
    },


    /**
     * Init behaviour on main Ptx map
     */
    prepareMainMap: function () {
        var self = this;
        var map = this.map;
        var map_data = map.data;

        google.maps.event.addListener(map_data, 'addfeature', function (e) {
            var feat = e.feature;
            var geomType = feat.getGeometry().getType();

            var showUnit = ($.inArray(feat.getProperty('unitId'), self.visibleUnits) > -1); //is unit visible = checked in table

            var type = feat.getProperty('type');

            if (geomType === 'Point') {
                var showPoint = showUnit || (type == 'POI'); //show POI

                if (showPoint) {
                    self.creators.createGeoPoint(self, feat);
                    if (type == 'vehicle' || type == 'BTS') {
                        self.geoBounds.extend(feat.getGeometry().get());
                    }
                } else {
                    feat.removeFromLayer = true;
                }
            } else if (geomType === 'LineString') { //TODO determine by type instead of geom?
                self.creators.createLineString(self, feat);
                // Show trip lines only for visible units, as these 'trips' are only few trackopints following
                // vehicle in motion.
                feat.removeFromLayer = !showUnit;
            } else if (type === 'gz') {
                self.creators.createGeoPoint(self, feat);
            }

        }); //addfeature

        self.onRightClickShowInsertPoi();
    },

    prepareSimpleMap: function () {
        var map = this.map;
        var d = map.data;

        function processPoints(geometry, callback, thisArg) {
            if (geometry instanceof google.maps.LatLng) {
                callback.call(thisArg, geometry);
            } else if (geometry instanceof google.maps.Data.Point) {
                callback.call(thisArg, geometry.get());
            } else {
                geometry.getArray().forEach(function (g) {
                    processPoints(g, callback, thisArg);
                });
            }
        }

        var bounds = this.geoBounds;
        google.maps.event.addListener(d, 'addfeature', function (e) {
            var feat = e.feature;
            processPoints(feat.getGeometry(), bounds.extend, bounds);
            map.fitBounds(bounds);
        });
    },

    prepareTraceMap: function () {
        var self = this;
        var map = this.map;
        var d = map.data;

        function processPoints(geometry, callback, thisArg) {
            if (geometry instanceof google.maps.LatLng) {
                callback.call(thisArg, geometry);
            } else if (geometry instanceof google.maps.Data.Point) {
                callback.call(thisArg, geometry.get());
            } else {
                geometry.getArray().forEach(function (g) {
                    processPoints(g, callback, thisArg);
                });
            }
        }

        var bounds = this.geoBounds;
        google.maps.event.addListener(d, 'addfeature', function (e) {
            var feat = e.feature;
            processPoints(feat.getGeometry(), bounds.extend, bounds);
            if (feat.getGeometry() instanceof google.maps.Data.Point && feat.getProperty('type') != 'vehicle') {
                self.creators.createTracePoint(self, feat.getGeometry().get(), feat);
            } else if (feat.getProperty('type') == 'vehicle') {
                self.creators.createTraceVehicle(self, feat);
            }
        });

        google.maps.event.addListener(map, "rightclick", function (event) {
            if (typeof self.rightClickTracePlan === 'function') {
                self.rightClickTracePlan(event)
            }
        });

    },

    /**
     * Prepares map type {@link Ptx.maps.TYPE_TRACE_ANALYZE} to draw added features into the map, so that analysis of the trace is visible.
     */
    prepareTraceAnalyzeMap: function () {
        var self = this;
        var map = this.map;
        var d = map.data;

        function processPoints(feature, geometry, callback, thisArg) {
            if (geometry instanceof google.maps.LatLng) {
                callback.call(thisArg, geometry);
            } else if (geometry instanceof google.maps.Data.Point) {
                if (feature.getProperty('type') == 'TracePlanPoi') {
                    // Adds point with tooltip info about planned point in TracePlan.
                    self.creators.createTracePoint(self, geometry.get(), feature);
                } else {
                    // Adds common point with tooltip info.
                    self.creators.createGeoPoint(self, feature);
                    self.geoBounds.extend(geometry.get());
                }
            } else if (feature.getProperty('type') == 'vehicle') {
                self.creators.createTraceVehicle(self, feature);
            } else {
                geometry.getArray().forEach(function (g) {
                    processPoints(feature, g, callback, thisArg);
                });
            }
        }

        var bounds = this.geoBounds;
        google.maps.event.addListener(d, 'addfeature', function (e) {
            var feature = e.feature;
            processPoints(feature, feature.getGeometry(), bounds.extend, bounds);
        });
    },

    /**
     * Init logbook map
     */
    prepareLogbookMap: function () {
        var self = this;
        var map = this.map;

        var d = map.data;
        var creators = self.creators;

        google.maps.event.addListener(d, 'addfeature', function (e) {
            var feat = e.feature;
            var type = feat.getGeometry().getType();
            var propType = feat.getProperty('type');

            if (type === 'Point') {
                creators.createGeoPoint(self, feat);
                if ((feat.getProperty('type') != 'POI') || (self.opts.extendBoundsToPOI == true)) {
                    self.geoBounds.extend(feat.getGeometry().get());
                }
            } else if (type === 'LineString') {
                feat.removeFromLayer = creators.createLineString(self, feat);
                var latLngArray = feat.getGeometry().getArray();
                for (var latLng in latLngArray) {
                    self.geoBounds.extend(latLngArray[latLng]);
                }
            } else if (type === 'GeometryCollection' && propType == 'gz') {
                creators.createGeoPoint(self, feat);
            }

        }); //addfeature

        self.onRightClickShowInsertPoi();
    },

    onRightClickShowInsertPoi: function () {
        var self = this;
        var map = this.map;

        google.maps.event.addListener(map, "click", function (event) {
            if (self.poiMenu != null) self.poiMenu.close();
        });

        google.maps.event.addListener(self.map, "rightclick", function (event) {
            var lat = event.latLng.lat();
            var lng = event.latLng.lng();
            // populate yor box/field with lat, lng
            if (self.poiMenu != null) self.poiMenu.close();
            self.poiMenu = new google.maps.InfoWindow({
                content: self.createInsertGeozoneBox(lat, lng, Ptx.options.cId),
                position: new google.maps.LatLng(lat, lng)
            });

            google.maps.event.addListener(self.poiMenu, 'domready', function () {
                Ptx.fn.initShowModal($('#poiMenu-' + self.getJQueryIdSafeCoords(lat, lng)));
            });
            self.poiMenu.open(self.map);
        });
    },

    /**
     * Tools for creating vehicles, points etc.
     */
    creators: {
        /**
         * Get position from geometry
         */
        getPosition: function (g) {
            var m = new google.maps.Marker({ //helper for position, TODO remove
                position: g
            });
            return m.getPosition();
        },

        createLineString: function (self, feat) {
            var type = feat.getProperty('type');
            if (type == 'trip-fake') {
                var lineSymbol = self.getStyleForFeature(type);
                lineSymbol.strokeColor = feat.getProperty('color');
                lineSymbol.strokeOpacity = 0.5;
                var line = new google.maps.Polyline({
                    path: feat.getGeometry().getArray(),
                    strokeOpacity: 0,
                    icons: [{
                        icon: lineSymbol,
                        offset: '0',
                        repeat: lineSymbol.dashSpacing
                    }],
                    map: self.map
                });
                self.fakeTrip.push(line);

                return true;
            }
            return false;
        },

        /**
         * Create all available types of points (vehicle, tp, eod, poi)
         * @param self
         * @param feat
         */
        createGeoPoint: function (self, feat) {
            var t = feat.getProperty('type');

            if (t == 'vehicle') {
                self.creators.createVehicle(self, feat);
            } else if (t == 'POI') {
                self.creators.createPOI(self, feat);
            } else if (t == 'BTS') {
                self.creators.createBTS(self, feat);
            } else if (t == 'GPSD') {
                self.creators.createGPSD(self, feat);
            } else if (t == 'trackBreak') {
                self.creators.createTrackBreak(self, feat);
            } else if (t == 'report') {
                self.creators.createReportTp(self, feat);
            } else if (t.startsWith('tp_')) {
                self.creators.createTp(self, feat);
            } else if (t == 'gz') {
                self.creators.createGeozone(self, feat)
            }
        },

        /**
         * Create POI (Point Of Interest)
         * @param self
         * @param feat
         */
        createPOI: function (self, feat) {
            var name = feat.getProperty('name');
            var radius = feat.getProperty('radius');
            var center = self.creators.getPosition(feat.getGeometry().get());
            var labelClass = 'label-poi';

            if (self.showPoiLabels == false) {
                labelClass = 'label-poi hidden';
            }

            var marker = new MarkerWithLabel({
                position: center,
                icon: {
                    url: getUrl('/img/u/map/poi_small.png'),
                    // The anchor for this image is the base of the flagpole at (0, 32).
                    anchor: new google.maps.Point(8, 30)
                },
                labelContent: name,
                visible: self.showPoi,
                labelClass: labelClass,
                labelAnchor: new google.maps.Point(20, 48)
            });

            feat.removeFromLayer = true;

            var circle = new google.maps.Circle({
                center: {
                    lat: center.lat(),
                    lng: center.lng()
                },
                clickable: false,
                fillColor: '#9B53C3',
                fillOpacity: 0.25,
                visible: self.showPoi,
                radius: radius,
                strokeWeight: 0
            });

            circle.getPosition = circle.getCenter
            //Add marker to particular cluster
            self.clusters['poi-marker'].addMarker(marker);
            self.clusters['poi-circle'].addMarker(circle);
            //Add marker to array of pois
            self.poi.push(marker);
            self.poi.push(circle);
        },


		createGeozone: function (self, feature) {
			feature.removeFromLayer = true;
			const geometry = feature.getGeometry();
			const center = calculateCenter(geometry);

			const mark = new MarkerWithLabel({
				position: self.creators.getPosition(center),
				icon: {
					url: getUrl('/img/u/map/poi_small.png'),
					anchor: new google.maps.Point(8, 30)
				},
				labelContent: feature.getProperty("name"),
				visible: self.showGeozone,
				labelClass: 'label-geozone',
				labelStyle: {
					backgroundColor: feature.getProperty("color"),
					color: self.getContrastColor(feature.getProperty("color"))
				},
				labelAnchor: new google.maps.Point(20, 48)
			});
			var shape;

			if (feature.getProperty("radius") !== 0 && feature.getProperty("gzType") === "POINT") {
				shape = new google.maps.Circle({
					center: {
						lat: center.lat(),
						lng: center.lng()
					},
					clickable: false,
					fillColor: feature.getProperty("color"),
					fillOpacity: 0.25,
					visible: self.showGeozone,
					radius: feature.getProperty("radius"),
					strokeWeight: 0
				});
				shape.getPosition = shape.getCenter;

			} else if (feature.getProperty("gzType") === "POLYGON") {
				const geometryCoordinates = geometry.getArray()[0].getArray();

				if (Array.isArray(geometryCoordinates)) {
					const paths = geometryCoordinates.flatMap(coord => {
						const coordArray = coord.Eg;

						if (Array.isArray(coordArray) && coordArray.length > 0) {
							return coordArray.map(point => {
								const lat = typeof point.lat === 'function' ? parseFloat(point.lat()) : null;
								const lng = typeof point.lng === 'function' ? parseFloat(point.lng()) : null;

								return (!isNaN(lat) && !isNaN(lng)) ? { lat, lng } : null;
							}).filter(Boolean);
						} else {
							return [];
						}
					});

					if (paths.length > 0) {
						shape = new google.maps.Polygon({
							paths: paths,
							clickable: false,
							fillColor: feature.getProperty("color"),
							fillOpacity: 0.25,
							strokeWeight: 0
						});

						shape.getCenter = function() {
							return calculatePolygonCenter(paths);
						};
						shape.getPosition = shape.getCenter;
					}
				}
			} if (feature.getProperty("gzType") === "POLYLINE") {

				const latLngs = [];
				feature.getGeometry().forEachLatLng(ll => latLngs.push(ll));

				const path = latLngs.map(ll => ({
					lat: ll.lat(),
					lng: ll.lng()
				}));

				shape = new google.maps.Polygon({
					paths:    path,
					clickable: false,
					fillColor: feature.getProperty("color"),
					fillOpacity: 0.25,
					strokeWeight: 0,
					visible: this.showGeozone
				});

				shape.getCenter = () => calculatePolygonCenter(path);
				shape.getPosition = shape.getCenter;
			}

			if (self.showGeozone == true && mark && shape) {
				self.clusters['geozone-marker'].addMarker(mark);
				self.clusters['geozone-circle'].addMarker(shape);
				self.geos.push(shape);
				self.geos.push(mark);
			}

			function calculateCenter(geom) {
				let bounds = new google.maps.LatLngBounds();
				geom.forEachLatLng(it => {
					bounds.extend(it);
				});
				return bounds.getCenter();
			}

			function calculatePolygonCenter(paths) {
				let latSum = 0, lngSum = 0;
				paths.forEach(coord => {
					latSum += coord.lat;
					lngSum += coord.lng;
				});
				return new google.maps.LatLng(latSum / paths.length, lngSum / paths.length);
			}
		},

        /**
         * Create BTS
         * @param self
         * @param feat
         */
        createBTS: function (self, feat) {
            const name = feat.getProperty('name');
            const radius = feat.getProperty('radius');
            const center = self.creators.getPosition(feat.getGeometry().get());

            var marker = new MarkerWithLabel({
                position: center,
                icon: {
                    path: google.maps.SymbolPath.CIRCLE,
                    scale: 0
                },
                labelContent: name,
                labelClass: 'label-bts',
                map: self.map
            });

            feat.removeFromLayer = true;

            const circle = new google.maps.Circle({
                center: {lat: center.lat(), lng: center.lng()},
                clickable: false,
                fillColor: '#D44848',
                fillOpacity: 0.12,
                map: self.map,
                radius: radius,
                strokeWeight: 0
            });

            self.bts.push(marker);
            self.bts.push(circle);
        },

        /**
         * Create GPSD point
         * @param self
         * @param feat
         */
        createGPSD: function (self, feat) {
            // var single = feat.getProperty('singleGpsd'); //is this only one GPSD, or is mixed within other TPs //TODO implement it?
            var addr = feat.getProperty('address');
            var time = feat.getProperty('time');

            feat.removeFromLayer = true; //remove this feature from data layer

            var marker = new MarkerWithLabel({
                position: self.creators.getPosition(feat.getGeometry().get())
                , labelAnchor: new google.maps.Point(20, 48)
                , labelContent: self.getVehicleMarker({
                    ico: feat.getProperty('ico'),
                    state: feat.getProperty('state'),
                    color: feat.getProperty('color'),
                    info: '',
                    type: feat.getProperty('ico'),
                    speed: feat.getProperty('speed')
                })
                , labelClass: 'label-vehicle'
                , icon: ' '
            });
            //ptx additional info for marker
            marker.ptx = {
                type: feat.getProperty('ico'),
            };
            self.clusters['vehicle'].addMarker(marker);
            var contentId = 'info-window-unit' + feat.getProperty('unitId');
            var info = new google.maps.InfoWindow({
                content: self.getVehicleInfoBox({
                    time: time, address: addr, domId: contentId, authorities: {}, hideButtonPanel: true
                }),
                pixelOffset: new google.maps.Size(0, -30)
            });

            //click on marker, hide current info box and show other
            google.maps.event.addListener(marker, 'click', function () {

                if (self.currentInfoBox) {
                    self.currentInfoBox.close();
                }

                info.open(self.map, marker);

                self.currentInfoBox = info;
                if (Ptx.resolver) {
                    var content = $('#' + contentId);
                    Ptx.resolver.bulkResolve('trackPoint', content);
                    Ptx.resolver.msgResolve(content);
                }
            });
            //close infobox on click to map
            google.maps.event.addListener(self.map, 'click', function () {
                if (self.currentInfoBox) {
                    self.currentInfoBox.close();
                }
            });

            var zindex; // for save zindex history
            google.maps.event.addListener(marker, 'mouseover', function () {
                zindex = this.zIndex;
                this.setOptions({zIndex: 8000});
            });
            google.maps.event.addListener(marker, 'mouseout', function () {
                this.setOptions({zIndex: zindex});
            });
        },

        /**
         * Create track break trackpoint
         * @param self
         * @param feat
         */
        createTrackBreak: function (self, feat) {
            var marker = new MarkerWithLabel({
                position: self.creators.getPosition(feat.getGeometry().get()),
                labelAnchor: new google.maps.Point(20, 48)
                , labelContent: self.getVehicleMarker({
                    ico: feat.getProperty('ico'),
                    state: feat.getProperty('state'),
                    name: feat.getProperty('name'),
                    color: feat.getProperty('color'),
                    info: '',
                    type: feat.getProperty('ico'),
                    speed: feat.getProperty('speed')
                })
                , labelClass: 'label-vehicle'
                , icon: ' '
            });
            var info = new google.maps.InfoWindow({
                content: self.getTrackBreakInfoBox({
                    name: feat.getProperty('name'),
                    lat: feat.getGeometry().get().lat(), lon: feat.getGeometry().get().lng(),
                    address: feat.getProperty('address')
                }),

                pixelOffset: new google.maps.Size(0, -30)
            });

            //click on marker, hide current info box and show other
            google.maps.event.addListener(marker, 'click', function () {
                if (self.currentInfoBox) {
                    self.currentInfoBox.close();
                }

                info.open(self.map, marker);
            });

            feat.removeFromLayer = true;
            self.clusters['tp'].addMarker(marker);

        },
        /**
         * Create marker to cluster for vehicle
         * @param feat Feature to create from
         */
        createVehicle: function (self, feat) {
            feat.removeFromLayer = true; //remove this feature from data layer

            const marker = new MarkerWithLabel({
                position: self.creators.getPosition(feat.getGeometry().get()),
                labelAnchor: new google.maps.Point(20, 48),
                labelContent: self.getVehicleMarker({
                    ico: feat.getProperty('ico'),
                    state: feat.getProperty('state'),
                    name: feat.getProperty('label'),
                    displayDriverName: feat.getProperty('displayDriverName'),
                    driver: feat.getProperty('driver'),
                    color: feat.getProperty('color'),
                    info: '',
                    type: feat.getProperty('ico'),
                    speed: feat.getProperty('speed')
                }),
                labelClass: 'label-vehicle',
                icon: ' '
            });
            //ptx additional info for marker
            marker.ptx = {
                type: feat.getProperty('ico'),
            };
            self.clusters['vehicle'].addMarker(marker);
            var contentId = 'info-window-unit' + feat.getProperty('unitId');
            var info = new google.maps.InfoWindow({
                content: self.getVehicleInfoBox({
                    unitId: feat.getProperty('unitId'), name: feat.getProperty('label'), time: feat.getProperty('time'),
                    lat: feat.getGeometry().get().lat(), lon: feat.getGeometry().get().lng(),
                    speed: feat.getProperty('speed'), address: feat.getProperty('address'),
                    regPlate: feat.getProperty('registrationPlate'), domId: contentId,
                    authorities: feat.getProperty('authorities'), driver: feat.getProperty('driver'),
                    trackNote: feat.getProperty('trackNote')
                }),
                pixelOffset: new google.maps.Size(0, -30)
            });

            //click on marker, hide current info box and show other
            google.maps.event.addListener(marker, 'click', function () {

                if (self.currentInfoBox) {
                    self.currentInfoBox.close();
                }

                google.maps.event.addListener(info, 'domready', function () {
                    Ptx.fn.initShowModal($('#fullmap'));
                })

                info.open(self.map, marker);

                self.currentInfoBox = info;
                if (Ptx.resolver) {
                    Ptx.resolver.bulkResolve('trackPoint', $('#' + contentId));
                    Ptx.resolver.msgResolve($('#' + contentId));
                }
            });
            //close infobox on click to map
            google.maps.event.addListener(self.map, 'click', function () {
                if (self.currentInfoBox) {
                    self.currentInfoBox.close();
                }
            });

            var zindex; // for save zindex history
            google.maps.event.addListener(marker, 'mouseover', function () {
                zindex = this.zIndex;
                this.setOptions({zIndex: 8000});
            });
            google.maps.event.addListener(marker, 'mouseout', function () {
                this.setOptions({zIndex: zindex});
            });

        }, //createVehicle
        /**
         * Create animated marker
         * @param feat Feature to create from
         * @param vehicle
         * @param latlng
         */
        createAnimatedVehicle: function (self, vehicle, latlng) {
            self.animatedMarker = new MarkerWithLabel({
                position: new google.maps.LatLng(latlng['lat'], latlng['lon']),
                labelAnchor: new google.maps.Point(20, 48),
                labelContent: self.getVehicleMarker(vehicle),
                labelClass: 'label-vehicle',
                icon: ' ',
                map: self.map
            });
        },

        /**
         * Common function to create tooltip for showing information about point.
         * @param self context
         * @param info created google.maps.InfoWindow with custom information about point
         * @param tpContentId unique ID of this tooltip window
         * @param marker marker for the point
         */
        createPointTooltip: function (self, info, tpContentId, marker) {
            if (!info) {
                return;
            }
            if (Ptx.fn.isMobile()) {
                google.maps.event.addListener(marker, 'click', function () {
                    if (self.currentInfoBox) {
                        self.currentInfoBox.close();
                    }
                    info.open(self.map, marker);
                    self.currentInfoBox = info;
                    if (Ptx.resolver) {
                        var tpContent = $('#' + tpContentId);
                        Ptx.resolver.bulkResolve('trackPoint', tpContent);
                        Ptx.resolver.msgResolve(tpContent);
                    }
                });

                //close infobox on click to map
                google.maps.event.addListener(self.map, 'click', function () {
                    if (self.currentInfoBox) {
                        self.currentInfoBox.close();
                    }
                });

            } else {
                if (!marker.mouseoverLisnener)
                    marker.mouseoverLisnener = google.maps.event.addListener(marker, 'mouseover', function () {
                        if (self.currentInfoBox) {
                            self.currentInfoBox.close();
                        }
                        if (!marker.domreadyListener)
                            marker.domreadyListener = google.maps.event.addListener(info, 'domready', function () {
                                if (Ptx.resolver) {
                                    var tpContent = $('#' + tpContentId);
                                    Ptx.resolver.bulkResolve('trackPoint', tpContent);
                                    Ptx.resolver.msgResolve(tpContent);
                                }
                                if (marker.domreadyListener)
                                    google.maps.event.removeListener(marker.domreadyListener);
                            });
                        info.open(self.map, marker);
                        self.currentInfoBox = info;
                    });
                if (!marker.mouseoutListener)
                    marker.mouseoutListener = google.maps.event.addListener(marker, 'mouseout', function () {
                        info.close();
                    });
            }
        },
        /**
         * Create TP or EOD from feature
         */
        createTp: function (self, feat) {
            const state = feat.getProperty('state'),
                type = feat.getProperty('type'),
                isRT41 = feat.getProperty('recordType') === 41,
                sprite_size = 16,
                marker_info = getMarkerInfo(),
                sprite_origin = marker_info.sprite;

            feat.removeFromLayer = true; //remove this feature from data layer

            var marker = new google.maps.Marker({
                position: self.creators.getPosition(feat.getGeometry().get()),
                anchorPoint: new google.maps.Point(0, 0),
                icon: {
                    url: getUrl("/img/u/map/marker-sprite-icons.png"),
                    origin: new google.maps.Point(sprite_origin[0], sprite_origin[1]),
                    size: new google.maps.Size(isRT41 ? sprite_size * 2 : sprite_size, sprite_size),
                    anchor: new google.maps.Point(8, 8)
                },
                map: self.map,
                zIndex: feat.getProperty('type') === "tp_eod" ? 1000 : 0,
            });

			if (marker_info.icon === "arrow" && !type.includes("tp_eod")) {
				marker.ptx = {
					time: feat.getProperty('time'),
					unixTime: feat.getProperty('unixTime')
				};
				self.clusters['tp'].addMarker(marker);
			} else {
				marker.setMap(self.map);
			}

            const tpContentId = 'info-window-tp-' + feat.getProperty('tpId');
            const info = new google.maps.InfoWindow({
                content: self.getTpInfoBox({
                    speed: feat.getProperty('speed'),
                    address: feat.getProperty('address'),
                    lat: feat.getGeometry().get().lat(),
                    lon: feat.getGeometry().get().lng(),
                    tpId: feat.getProperty('tpId'),
                    time: feat.getProperty('time'),
                    header1: feat.getProperty('header1'),
                    header2: feat.getProperty('header2'),
                    driver: feat.getProperty('driver'),
                    domId: tpContentId
                }),
                pixelOffset: new google.maps.Size(0, -5)
            });

            this.createPointTooltip(self, info, tpContentId, marker);

            function getMarkerInfo() {
                const rotation = feat.getProperty('course'), order = feat.getProperty('order');
                var icon = "", sprite = []; // [pocet kroku doprava, pocet kroku dolu]

                if (state === "FAKE_STOP") {
                    icon = "point";
                    sprite = [0, 6 * sprite_size];
                } else if (state === "STOP") {
                    icon = "point";
                    sprite = [sprite_size, 6 * sprite_size];
                } else if (state === "GLOBAL_START") {
                    icon = "point";
                    sprite = [2 * sprite_size, 6 * sprite_size];
                } else if (state === "GLOBAL_STOP") {
                    icon = "point";
                    sprite = [3 * sprite_size, 6 * sprite_size];
                } else if (type === 'tp_eod' && !isRT41) {
                    icon = "arrow";
                    sprite = [4 * sprite_size, 6 * sprite_size];
                } else if (type === 'tp_eod' && isRT41) {
                    icon = "arrow";
                    sprite = [Math.floor(rotation / 30) * sprite_size * 2, 5 * sprite_size]; // 30 for arrow degree
                } else {
                    icon = "arrow";
                    sprite = [Math.floor(rotation / 30) * sprite_size, order * sprite_size]; // 30 for arrow degree
                }

                return {"icon": icon, "sprite": sprite};
            }
        }, //createTp

        /**
         * Create report TP
         */
        createReportTp: function (self, feat) {
            var t = feat.getProperty('type');
            var marker = new MarkerWithLabel({
                position: self.creators.getPosition(feat.getGeometry().get()),
                labelAnchor: new google.maps.Point(20, 48),
                labelContent: self.getVehicleMarker({
                    ico: feat.getProperty('ico'),
                    state: feat.getProperty('state'),
                    name: feat.getProperty('name'),
                    color: feat.getProperty('color'),
                    info: '',
                    type: feat.getProperty('ico')
                }),
                labelClass: 'label-vehicle',
                icon: ' '
            });
            feat.removeFromLayer = true; //remove this feature from data layer
            self.clusters['tp'].addMarker(marker);

        }, //createreportTp

        /**
         * Create mark with car on map after click to chart
         * @param self
         * @param vehicle
         * @param latlng
         */
        createPoint: function (self, vehicle, latlng) {
            if (self.currentPoint != null) {
                self.currentPoint.setMap(null);
            }
            self.currentPoint = new MarkerWithLabel({
                position: new google.maps.LatLng(latlng['lat'], latlng['lon']),
                labelAnchor: new google.maps.Point(20, 48),
                labelContent: self.getVehicleMarker(vehicle),
                labelClass: 'label-vehicle',
                icon: ' ',
                map: self.map
            });
            self.centerAndZoom(latlng['lat'], latlng['lon'], self.map.zoom);
        },

        /**
         * Create mark with car on map after click to chart
         * @param self
         * @param latLng
         * @param feat
         * @param data
         */
        createTracePoint: function (self, latLng, feat, data) {
            if (!data)
                data = {
                    draggable: self.geoMarkersDraggable,
                    color: 'black',
                    radius: 0
                }

            data.opacity = 0.9;

            if (feat) {
                if (feat.getProperty('resolved')) {
                    data.draggable = true;
                    data.opacity = 0.5;
                }

                if (feat.getProperty('order'))
                    data.order = feat.getProperty('order');

                if (feat.getProperty('color'))
                    data.color = feat.getProperty('color');

                if (feat.getProperty('radius'))
                    data.radius = feat.getProperty('radius');

                feat.removeFromLayer = true; //remove this feature from data layer
                /**
                 * Incomprehensible behavior:
                 * localhost and test:
                 * feat:
                 * g: _.Ze {g: _.L}
                 * h: {tpId: -1, entry: null, address: "", resolve: null, resolveAction: null, …}
                 * i: "-1"
                 * staging and production:
                 * feat:
                 * j: _.ze {j: _.R}
                 * l: {tpId: -1, entry: null, address: "", resolve: null, resolveAction: null, …}
                 * m: "-1"
                 */
                if (feat.h !== undefined) {
                    data.id = feat.h.tpId;
                } else if (feat.l !== undefined) {
                    data.id = feat.l.tpId;
                }
            }

            var label = '';
            var labelText = '';
            if (data.order) {
                labelText = data.order.toString();
            }
            var path = 'M40,0C26.191,0,15,11.194,15,25c0,23.87,25,55,25,55s25-31.13,25-55C65,11.194,53.807,0,40,0z     M40,38.8c-7.457,0-13.5-6.044-13.5-13.5S32.543,11.8,40,11.8c7.455,0,13.5,6.044,13.5,13.5S47.455,38.8,40,38.8z';
            if (labelText) {
                path = 'M40,0C26.191,0,15,11.194,15,25c0,23.87,25,55,25,55s25-31.13,25-55C65,11.194,53.807,0,40,0z'
                label = {
                    text: labelText,
                    color: "#fff",
                    fontSize: "12px",
                }
            }

            var marker = new google.maps.Marker({
                draggable: data.draggable,
                position: latLng,
                label: label,
                map: self.map,
                icon: {
                    path: path,
                    fillColor: data.color,
                    fillOpacity: data.opacity,
                    scale: 0.4,
                    strokeWeight: 1,
                    labelOrigin: new google.maps.Point(40, 30),
                    anchor: new google.maps.Point(40, 80),
                },
                customInfo: data.order,
                markerId: data.id
            });
            self.geoMarkers.push(marker)

            if (!data.draggable && data.radius > 0) {
                var circle = new google.maps.Circle({
                    center: latLng,
                    clickable: false,
                    fillColor: data.color,
                    fillOpacity: 0.25,
                    map: self.map,
                    radius: data.radius,
                    strokeWeight: 0,
                    circleId: data.id
                });

                self.geoMarkers.push(circle)
            }

            marker.addListener('dragend', function (e) {
                if (typeof self.markerDragend === 'function') {
                    self.markerDragend(e, data.id)
                }
            })

            /** Tooltip info  */
            if (feat) {
                var tpContentId = 'info-window-tp-' + feat.getProperty('tpId');
                var info = new google.maps.InfoWindow({
                    content: self.getTpInfoBox({
                        address: feat.getProperty('address'),
                        lat: feat.getGeometry().get().lat(),
                        lon: feat.getGeometry().get().lng(),
                        entry: feat.getProperty('entry'),
                        resolve: feat.getProperty('resolve'),
                        resolveAction: feat.getProperty('resolveAction'),
                        domId: tpContentId
                    })
                });
            }

            this.createPointTooltip(self, info, tpContentId, marker);
        },

        /**
         * Create marker to cluster for vehicle
         * @param feat Feature to create from
         */
        createTraceVehicle: function (self, feat) {
            feat.removeFromLayer = true; //remove this feature from data layer
            var marker = new MarkerWithLabel({
                position: self.creators.getPosition(feat.getGeometry().get()),
                labelAnchor: new google.maps.Point(20, 48)
                , labelContent: self.getVehicleMarker({
                    ico: feat.getProperty('ico'),
                    state: feat.getProperty('state'),
                    name: feat.getProperty('name'),
                    color: feat.getProperty('color'),
                    info: '',
                    type: feat.getProperty('ico'),
                    speed: feat.getProperty('speed')
                })
                , labelClass: 'label-vehicle'
                , icon: ' ',
                map: self.map
            });

            self.geoMarkers.push(marker)
            //ptx additional info for marker
            marker.ptx = {
                type: feat.getProperty('ico'),
            };
            var contentId = 'info-window-unit' + feat.getProperty('unitId');
        },
    },

    removeGeoFeatures: function () {
        var map = this.map;
        map.data.forEach(function (feat) {
            map.data.remove(feat);
        });
        //clear fakeTrips
        for (var i = 0; i < this.fakeTrip.length; i++) {
            this.fakeTrip[i].setMap(null); // removes fakeTrip from map
        }
        this.fakeTrip = [];
    },


    removeGeoMarkers: function () {
        if (this.geoMarkers) {
            this.geoMarkers.forEach(function (m) {
                if (typeof m.setMap === 'function')
                    m.setMap(null);
            })
        }
        this.geoMarkers = []
    },

    /**
     * Removes marker and it's circle from map according to id parameter. ID is set into the geoMarker object (marker, circle)
     * in {@link createTracePoint} function.
     * @param id identification of the geoMarker, usually TrackPoint ID is used for this purpose.
     */
    removeGeoMarkerById: function (id) {
        if (this.geoMarkers) {
            this.geoMarkers.forEach(function (m) {
                if ((m.markerId && m.markerId === id) || (m.circleId && m.circleId === id)) {
                    m.setMap(null);
                }
            });
        }
    },

    changeTitleGeoMarkerById: function (id, title) {
        if (this.geoMarkers) {
            this.geoMarkers.forEach(function (m) {
                if (m.markerId && m.markerId === id) {
                    var label = m.getLabel()
                    label.text = title
                    m.setLabel(label)
                }
            });
        }
    },

    /** @see maps/base#markerShowLabels */
    markerShowLabels: function (type, show) {
        this.base(type, show);
        //TODO refactor to use class "vehicle-marker" and "vehicle-marker-type-???"
        var obj = this.clusters;

        for (var prop in obj) {
            if (obj.hasOwnProperty(prop) && prop === "vehicle") {
                var ms = obj[prop].getMarkers();

                for (var i = 0; i < ms.length; i++) {
                    if (type == "ALL" || ms[i].ptx.type == type) {
                        var ctn = $(ms[i].labelContent);
                        if (ctn[0]) {
                            var title = $('.title', ctn);
                            if (this.showLabels) {
                                title.removeClass('hidden');
                            } else {
                                title.addClass('hidden')
                            }
                            //ms[i].set("labelVisible", show);

                            ms[i].set("labelContent", ctn[0].outerHTML);
                        }
                    }
                }
            }
        }
    },

    /** @see maps/base#forceRefreshMap */
    forceRefreshMap: function () {
        google.maps.event.trigger(this.map, 'idle');
    },

    /** @see maps/base#createPoint */
    createPoint: function (element) {
        var car = {
            ico: element.objectType,
            state: "",
            color: element.color,
            info: "",
            name: element.name,
            type: "car",
            tz: "Europe/Prague"
        };
        this.creators.createPoint(this, car, element.latLon);
    },

    extendGeoBounds: function (latLng) {
        this.geoBounds.extend(latLng);
    }

});

const GRAYSCALE_MAP_TYPE = [
	{
		"featureType": "all",
		"elementType": "geometry",
		"stylers": [{"color": "#f5f5f5"}]
	},
	{
		"featureType": "all",
		"elementType": "labels.icon",
		"stylers": [{"visibility": "off"}]
	},
	{
		"featureType": "all",
		"elementType": "labels.text.fill",
		"stylers": [{"color": "#616161"}]
	},
	{
		"featureType": "all",
		"elementType": "labels.text.stroke",
		"stylers": [{"color": "#f5f5f5"}]
	},
	{
		"featureType": "administrative.land_parcel",
		"elementType": "labels.text.fill",
		"stylers": [{"color": "#bdbdbd"}]
	},
	{
		"featureType": "administrative.country",
		"elementType": "geometry.stroke",
		"stylers": [{"color": "#6f6f6f"}, {"weight": 1}]
	},
	{
		"featureType": "administrative.province",
		"elementType": "geometry.stroke",
		"stylers": [{"color": "#adadad"}, {"weight": 0.8}]
	},
	{
		"featureType": "administrative.locality",
		"elementType": "geometry.stroke",
		"stylers": [{"color": "#cdcdcd"}, {"weight": 0.6}]
	},
	{
		"featureType": "poi",
		"elementType": "geometry",
		"stylers": [{"color": "#eeeeee"}]
	},
	{
		"featureType": "poi",
		"elementType": "labels.text.fill",
		"stylers": [{"color": "#757575"}]
	},
	{
		"featureType": "poi.park",
		"elementType": "geometry",
		"stylers": [{"color": "#e5e5e5"}]
	},
	{
		"featureType": "poi.park",
		"elementType": "labels.text.fill",
		"stylers": [{"color": "#9e9e9e"}]
	},
	{
		"featureType": "road",
		"elementType": "geometry",
		"stylers": [{"color": "#ffffff"}]
	},
	{
		"featureType": "road.arterial",
		"elementType": "labels.text.fill",
		"stylers": [{"color": "#757575"}]
	},
	{
		"featureType": "road.highway",
		"elementType": "geometry",
		"stylers": [{"color": "#dadada"}]
	},
	{
		"featureType": "road.highway",
		"elementType": "labels.text.fill",
		"stylers": [{"color": "#616161"}]
	},
	{
		"featureType": "road.local",
		"elementType": "labels.text.fill",
		"stylers": [{"color": "#9e9e9e"}]
	},
	{
		"featureType": "transit.line",
		"elementType": "geometry",
		"stylers": [{"color": "#e5e5e5"}]
	},
	{
		"featureType": "transit.station",
		"elementType": "geometry",
		"stylers": [{"color": "#eeeeee"}]
	},
	{
		"featureType": "water",
		"elementType": "geometry",
		"stylers": [{"color": "#c9c9c9"}]
	},
	{
		"featureType": "water",
		"elementType": "labels.text.fill",
		"stylers": [{"color": "#9e9e9e"}]
	}
];
